var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuymeacoffee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0397 11.5764C16.5267 11.4447 16.0102 11.3574 15.4275 11.3574C14.4194 11.3574 13.6065 11.6182 12.6683 11.9197C11.6161 12.2587 10.4221 12.6426 8.87469 12.6426C8.22736 12.6423 7.58311 12.5756 6.95973 12.4445M18.0663 8.42076C18.0663 8.42076 16.762 19.3191 16.5391 20.6697C16.3162 22.0202 14.9781 22.4421 13.269 22.4421H10.7301C9.02093 22.4421 7.68289 22.0196 7.45998 20.6697C7.23708 19.3197 6.12263 8.7873 6.12263 8.7873M18.2151 5.44073C18.2151 5.44073 17.792 3.34802 17.6089 2.73113C17.2886 1.6489 13.1698 1.55786 11.9995 1.55786C10.8293 1.55786 6.26891 1.68799 6.26891 2.54853L5.5754 5.44073M11.9995 6.06886C14.5635 6.06886 17.6187 5.59013 18.585 5.44073C19.4117 5.31221 19.7363 5.92375 19.8851 6.63863C20.0339 7.35352 20.0651 8.05126 19.1392 8.22209C18.2133 8.39291 16.2647 8.84862 11.9995 8.84862C7.73432 8.84862 5.78575 8.39345 4.85922 8.22209C3.9327 8.05073 3.96515 7.35352 4.11396 6.63863C4.26277 5.92375 4.58733 5.31275 5.41403 5.44073C6.38036 5.59067 9.4355 6.06886 11.9995 6.06886Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuymeacoffee);
export default __webpack_public_path__ + "static/media/buymeacoffee.59e68214e4e232b9f070cd7b2d52b71b.svg";
export { ForwardRef as ReactComponent };